import { INIT, SUCCESS, LOADING, ERROR } from "../../../utils/constants";
import {
  GET_AZURE_ALERT_RULES,
  GET_AZURE_ALERT_RULES_SUCCESS,
  GET_AZURE_ALERT_RULES_ERROR,
} from "./constant";

const initialState = {
  phase: INIT,
  azureAlertRulesList: null,
  error: null,
};

/**
 * User Reducer
 * @param {Object} state
 * @param {Object} action
 */

export function AzureAlertRulesStore(state = initialState, action) {
  switch (action.type) {
    case GET_AZURE_ALERT_RULES:
      return {
        ...state,
        phase: LOADING,
      };
    case GET_AZURE_ALERT_RULES_SUCCESS:
      return {
        ...state,
        phase: SUCCESS,
        azureAlertRulesList: action.data,
        error: null,
      };
    case GET_AZURE_ALERT_RULES_ERROR:
      return { ...state, phase: ERROR, error: action.error };

    default:
      return state;
  }
}
